import React from "react";
import { BankDetails } from "../../interfaces/bank";
import { BankCard } from "./BankCard";

// ── Step 3a: Success ──────────────────────────────────────────────────────────
export function SuccessStep({ details, onEdit }: { details: BankDetails; onEdit: () => void }) {
  return (
    <div className="space-y-6">
      <h2 className="text-lg font-semibold text-gray-900">
        Bank Account Verified Successfully
      </h2>
      <BankCard details={details} />
      <div className="flex justify-end">
        <button
          onClick={onEdit}
          className="px-5 py-2 bg-gray-900 text-white rounded-lg text-sm font-medium hover:bg-gray-700 active:scale-95 transition-all duration-200"
        >
          Edit Bank Details
        </button>
      </div>
    </div>
  )
}